import { createSelector } from 'reselect';
import { DiscountsSubsection } from '../../types/store';
import { getStudioSlice } from './page';
import {
  SELLER_DISCOUNTS_ACTIVE_STREAM,
  SELLER_DISCOUNTS_SCHEDULED_STREAM,
  SELLER_DISCOUNTS_ENDED_STREAM,
} from '../../../constants';
import { getItems } from '@wix/da-shared-react/pkg/Stream/base/selectors';

export const getDiscountsSubsection = createSelector(
  [getStudioSlice],
  state => state.discounts?.subsection ?? DiscountsSubsection.Active
);

export const getDiscountLimitations = createSelector(
  [getStudioSlice],
  state => state.discounts?.limitations
);

export const getDiscountsCount = createSelector([state => state], state => {
  const active = getItems(state, SELLER_DISCOUNTS_ACTIVE_STREAM.streamId);
  const scheduled = getItems(state, SELLER_DISCOUNTS_SCHEDULED_STREAM.streamId);
  const ended = getItems(state, SELLER_DISCOUNTS_ENDED_STREAM.streamId);
  return (active?.length ?? 0) + (scheduled?.length ?? 0) + (ended?.length ?? 0);
});
